
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalCharging25 as ObiBatteryVerticalCharging25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-charging-25.js';
 
 
 

 
 export const ObiBatteryVerticalCharging25 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-charging-25',
   elementClass: ObiBatteryVerticalCharging25Element,
   events: {
     
   }
  });
 
 